"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _bookingJapan = require("@/api/bookSpace/bookingJapan");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _routeInfo = _interopRequireDefault(require("@/views/booking/bookingSpace/components/routeInfo.vue"));
var _utils = require("@/utils");
var _voyageDetails = _interopRequireDefault(require("@/views/booking/bookingSpace/components/voyageDetails.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    voyageDetails: _voyageDetails.default,
    routeInfo: _routeInfo.default,
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: null,
      searchFormRules: {
        pol: [{
          required: true,
          message: '',
          trigger: 'change'
        }],
        pod: [{
          required: true,
          message: '',
          trigger: 'change'
        }],
        etdStr: [{
          required: true,
          message: '',
          trigger: 'change'
        }]
      },
      selectTableData: {
        searrcForm: {},
        tabledata: []
      },
      voyageDetailsVisible: false,
      voyagePlanJpVo: {},
      showMainType: false,
      tableCostData: [],
      searchForm: {
        pol: '',
        pod: '',
        polName: '',
        podName: '',
        etdStr: '',
        tsFlag: '0',
        etaStr: '',
        vesselCode: '',
        serviceLineCode: ''
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      total: 0,
      tableData: [],
      hotSettings: {
        dragCheck: true,
        height: 'auto',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleViewDetail: function handleViewDetail(selectedRow) {
      this.voyagePlanJpVo = {
        vesselName: selectedRow.vesselName,
        vesselCode: selectedRow.vesselCode,
        voyageNo: selectedRow.voyageNo,
        voyageLeg: selectedRow.voyageLeg,
        serviceLineCode: selectedRow.serviceLineCode
      };
      this.voyageDetailsVisible = true;
    },
    checkSelectable: function checkSelectable(row) {
      return row.status !== 'X';
    },
    polChange: function polChange(value, data) {
      console.log('value,data', value, data);
      this.searchForm.polName = data.portName;
    },
    podChange: function podChange(value, data) {
      console.log('value,data', value, data);
      this.searchForm.podName = data.portName;
    },
    resetForm: function resetForm() {
      this.searchForm = {
        pol: '',
        pod: '',
        polName: '',
        podName: '',
        etdStr: '',
        tsFlag: '0',
        etaStr: '',
        vesselCode: '',
        serviceLineCode: ''
      };
    },
    searchFormData: function searchFormData() {
      var _this = this;
      if (!this.searchForm.pol) {
        this.$message({
          message: this.$t('booking.bookingJapan.polWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.searchForm.pod) {
        this.$message({
          message: this.$t('booking.bookingJapan.podWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.searchForm.etdStr) {
        this.$message({
          message: this.$t('booking.bookingJapan.etdStrWarning'),
          type: 'warning'
        });
        return;
      }
      this.loading = (0, _utils.load)();
      this.showMainType = true;
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      console.log('this.searchForm', this.searchForm);
      (0, _bookingJapan.svlVoyagePlan2queryList)(data).then(function (res) {
        _this.tableCostData = res.data.records;
        _this.listQuery.total = res.data.totalRecord;
        _this.selectionIds = [];
        console.log(' this.tableCostData', _this.tableCostData);
      }).catch(function (err) {}).finally(function () {
        _this.loading.close();
      });
    },
    hotTableSelect: function hotTableSelect(data) {
      var tableData = data;
      var array = [];
      if (this.searchForm.tsFlag == '0') {
        tableData.map(function (item, index) {
          array.push({
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            polEtaHidden: item.polEtaHidden,
            polEta: item.polEta,
            etd: item.etd,
            eta: item.eta,
            vesselCode: item.vesselCode,
            vesselNameCn: item.vesselNameCn,
            serviceLineCode: item.serviceLineCode,
            lineType: item.lineType,
            tripNumber: item.tripNumber,
            carrier: item.carrier,
            polHidden: item.polHidden,
            podHidden: item.podHidden
          });
        });
      } else {
        tableData.map(function (item, index) {
          array.push({
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            polEtaHidden: item.polEtaStr,
            polEta: item.polEta,
            etd: item.polEtdStr,
            eta: item.podEtaStr,
            vesselCode: item.vesselCode,
            vesselNameCn: item.vesselNameCn,
            serviceLineCode: item.serviceLineCode,
            lineType: item.lineType,
            tripNumber: item.tripNumber,
            carrier: item.carrier,
            polHidden: item.polHidden,
            podHidden: item.podHidden
          });
        });
      }
      this.selectTableData.tabledata = array;
      console.log('this.selectTableData.tabledata', this.selectTableData.tabledata);
      console.log('this.selectTableData', this.selectTableData);
    },
    /**
     * 序号随页码动态改变
     */
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.listQuery.currentPage - 1) * this.listQuery.pageSize;
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.currentPage = val;
      this.searchFormData();
    },
    /**
     * pageSize 改变时会触发
     */
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.searchFormData();
    },
    opened: function opened() {
      // this.handleSearch()
      console.log('opened');
      this.searchForm.etdStr = this.getNowFormatTime();
    },
    getNowFormatTime: function getNowFormatTime() {
      var nowDate = new Date();
      //补全0，并拼接
      return this.getNowFormatDay(nowDate);
    },
    getNowFormatDay: function getNowFormatDay(nowDate) {
      var char = "-";
      if (nowDate == null) {
        nowDate = new Date();
      }
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1
      var year = nowDate.getFullYear();
      //补全0，并拼接
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    completeDate: function completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    handleReset: function handleReset() {
      this.searchForm = {
        pol: '',
        pod: '',
        polName: '',
        podName: '',
        etdStr: '',
        tsFlag: '0',
        etaStr: '',
        vesselCode: '',
        serviceLineCode: '',
        currentPage: 1,
        pageSize: 10
      };
    },
    // handleSelectionChange() {
    //   this.multipleSelection=JSON.parse(JSON.stringify(this.$refs.hotTableCost.getSelections()))
    // },
    handleSubimt: function handleSubimt() {
      this.selectTableData.searrcForm = this.searchForm;
      console.log('this.multipleSelection', this.multipleSelection);
      if (this.selectTableData.tabledata) {
        this.$emit('selectionChange', this.selectTableData);
      } else {
        this.$message({
          message: this.$t('userCenter.billConsigneeApplication.isSelectData'),
          type: 'warning'
        });
      }
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    },
    handleClear: function handleClear() {
      this.searchForm = {
        pol: '',
        pod: '',
        polName: '',
        podName: '',
        etdStr: '',
        tsFlag: '0',
        etaStr: '',
        vesselCode: '',
        serviceLineCode: '',
        currentPage: 1,
        pageSize: 10
      };
    },
    closed: function closed() {
      this.handleClear();
    },
    handleSearch: function handleSearch() {
      var _this2 = this;
      if (!this.searchForm.pol) {
        this.$message({
          message: this.$t('booking.bookingJapan.polWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.searchForm.pod) {
        this.$message({
          message: this.$t('booking.bookingJapan.podWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.searchForm.etdStr) {
        this.$message({
          message: this.$t('booking.bookingJapan.etdStrWarning'),
          type: 'warning'
        });
        return;
      }
      this.loading = (0, _utils.load)();
      (0, _bookingJapan.svlVoyagePlan2queryList)(this.searchForm).then(function (res) {
        console.log('res', res);
        _this2.tableData = res.data.records;
        _this2.total = res.data.totalRecord;
      }).catch(function (err) {
        console.log('err', err);
      }).finally(function () {
        _this2.loading.close();
      });
    }
  }
};